import api from './api';

export const getFuncionarios = async () => {
  try {
    const response = await api.get('Funcionarios');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar funcionários:', error);
    throw error;
  }
};

export const deletarFuncionarioPorId = async (id) => {
  try {
    const response = await api.delete(`/Funcionarios/${id}`);
    return response;
  } catch (error) {
    console.error('Erro ao deletar funcionário:', error);
    throw error;
  }
};

export const criarFuncionario = async (info) => {
  try {
    const response = await api.post("Funcionarios", info);
    return response;
  } catch (e){
    console.error(e);
    throw e;
  }
}

export const editarFuncionarioPorId = async (id, info) => {
  try {
    const response = await api.put(`/Funcionarios/${id}`, info);
    return response;
  } catch (error) {
    console.error('Erro ao editar funcionário:', error);
    throw error;
  }
};
